import * as Sentry from '@sentry/react';
import { getSupabase, isSupabaseConfigured } from './supabase';

const APP_VERSION = '1.0.0';

/**
 * @param {unknown} error
 * @param {{ userId?: string|null, page?: string|null, action?: string|null, region?: string|null, country?: string|null, extra?: Record<string, unknown> }} [context]
 */
export async function logError(error, context = {}) {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.error(error);
    return;
  }

  try {
    if (process.env.REACT_APP_SENTRY_DSN) {
      Sentry.captureException(error, {
        tags: {
          page: context.page || 'unknown',
          action: context.action || 'unknown',
          region: context.region || '',
          country_code: context.country || '',
        },
        user: context.userId ? { id: context.userId } : undefined,
        extra: context.extra || undefined,
      });
    }
  } catch (sentryErr) {
    // eslint-disable-next-line no-console
    console.error('logError sentry failed:', sentryErr);
  }

  try {
    if (!isSupabaseConfigured) return;
    const supabase = getSupabase();
    if (!supabase) return;
    await supabase.from('error_logs').insert({
      user_id: context.userId || null,
      page: context.page || null,
      action: context.action || null,
      error_message: error && typeof error === 'object' && 'message' in error ? String(error.message) : String(error),
      error_stack: error && typeof error === 'object' && 'stack' in error ? String(error.stack) : null,
      region: context.region || null,
      country_code: context.country || null,
      app_version: APP_VERSION,
      resolved: false,
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('logError failed:', e);
  }
}

